module.exports = __webpack_public_path__ + "media/img/apple-icon-144x144-9d2cbe461a49a6240e37427e02fec34f.png";